import axios from "axios";

const http = axios.create({
    baseURL: (process.env.NODE_ENV === "production" ? "" : "http://localhost:8000") + "/api"
});
http.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

export default http;
